

























































import Vue from "vue";
import { getAllStates } from "@/actions";
import { locStr } from "@/utilities";
import { dataStore } from "@/main";
import * as Actions from "@/actions";
import MangoFpProcessSteps from "./MangoFpProcessSteps.vue";
import MangoFpParameters from "./MangoFpParameters.vue";

export default Vue.extend({
    name: "MangoFpSettingsMain",
    components: {
        MangoFpProcessSteps,
        MangoFpParameters,
    },
    data() {
        return {
            loading: true,
            globalState: dataStore,
            timeout: 3000,
        };
    },
    methods: {
        locStr(key: string): string {
            return locStr(key);
        },
        doOnChange() {
            Actions.clearGeneralMessage();
        },
    },
    async mounted() {
        const loaded = await getAllStates();
        this.loading = !loaded;
    },
});
